<div class="dialog-content compare-dialog-content">
  <!--title 標題-->
  <h1 class="dialog-title">
    {{ 'business-reserve-compare-choose-dialog.title' | translate }}
  </h1>

  <!--btn:關閉按鈕-->
  <button mat-button class="dialog-close-btn" (click)="closeDialog()">
    <img src="assets/img/i-close.svg" alt="" height="32" width="32" />
  </button>

  <div class="dialog-scroll-content">
    <div class="business-package-container">
      @for (packageDetail of packageDetails; track $index) {
        <div class="btn-card">
          <p class="btn-card-title">{{ packageDetail.packageName }}</p>
          <p class="btn-card-price">
            <label>$</label>{{ packageDetail.price | numberComma }}
          </p>

          <div class="btn-group">
            <button
              mat-button
              class="btn-outline-primary btn-size-l"
              (click)="selectPackage(packageDetail)"
            >
              {{
                'business-reserve-compare-choose-dialog.compare-this-package'
                  | translate
              }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
